import { SnailyPromise } from './SnailyPromise'

function waitAsync(seconds: number): Promise<void> {
	const result = new SnailyPromise<void>(function (resolve) {
		console.log(`delay is starting for ${seconds} seconds`)
		setTimeout(function () {
			resolve()
		}, seconds * 1000)
	})
	return result
}

async function randomWaitAsync(
	minSeconds: number,
	maxSeconds: number
): Promise<void> {
	const waitSeconds =
		Math.floor(Math.random() * (maxSeconds - minSeconds)) + minSeconds
	await waitAsync(waitSeconds)
}

export const delay = {
	waitAsync,
	randomWaitAsync
}
